import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { Subscription } from 'rxjs';
import { DistrictSimpleDto } from 'src/app/common/dtos/district.dto';
import { deepCopy } from 'src/app/common/utilities/copy.helpers';

import { SchoolDTO } from 'src/app/common/dtos/school.dto';
import {
  emptySmartAssistantFeedFilters,
  SmartAssistantFeedFilterDTO,
} from '../../../dtos/glai.dto';
import { DaterangePickerComponent } from '../../daterange-picker/daterange-picker.component';
import { DistrictSelectComponent } from '../../district-select/district-select.component';
import { ModalComponent } from '../../modals/modal/modal.component';
import { SchoolSelectComponent } from '../../school-select/school-select.component';
import { UserSelectComponent } from '../../user-select/user-select.component';

@Component({
  selector: 'app-smart-assistant-feed-filter-modal',
  standalone: false,
  templateUrl: './smart-assistant-feed-filter-modal.component.html',
  styleUrl: './smart-assistant-feed-filter-modal.component.scss',
})
export class SmartAssistantFeedFilterModalComponent
  implements AfterViewInit, OnInit, OnDestroy
{
  @Input() initialFilters: SmartAssistantFeedFilterDTO;

  @Output() readonly setFilters: EventEmitter<SmartAssistantFeedFilterDTO> =
    new EventEmitter<SmartAssistantFeedFilterDTO>();

  @Output() readonly modalClose: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('modal') modal: ModalComponent;

  @ViewChild('districtSelect') districtSelect: DistrictSelectComponent;

  @ViewChild('schoolSelect') schoolSelect: SchoolSelectComponent;

  @ViewChild('userSelect') userSelect: UserSelectComponent;

  @ViewChild('dateSelect') dateSelect: DaterangePickerComponent;

  subs: Subscription[] = [];

  currentFilters: SmartAssistantFeedFilterDTO;

  canSeeAllSchools = true;

  ngOnInit() {
    this.currentFilters =
      deepCopy(this.initialFilters) || emptySmartAssistantFeedFilters();
  }

  ngAfterViewInit() {
    this.modal.open();
    this.modal.isDismissing.subscribe(() => {
      this.modalClose.emit();
    });
  }

  closeModal(): void {
    this.setFilters.emit(this.currentFilters);
    this.modal.close();
    this.modalClose.emit();
  }

  clearFilters(district?: DistrictSimpleDto | null): void {
    this.currentFilters = emptySmartAssistantFeedFilters();
    if (district) {
      this.currentFilters.district = district;
    } else {
      this.districtSelect.reset();
    }
    this.schoolSelect.reset();
    this.userSelect.reset();
    this.dateSelect.clearDates();
  }

  updateSchools(schools: SchoolDTO[] | SchoolDTO) {
    this.currentFilters.schoolList =
      typeof schools === 'object' ? (schools as SchoolDTO[]) : [schools];
  }

  ngOnDestroy() {
    let sub = this.subs.pop();
    while (sub) {
      sub.unsubscribe();
      sub = this.subs.pop();
    }
  }
}
